import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=1555e6ad&scoped=true"
var script = {}
import style0 from "./loader.vue?vue&type=style&index=0&id=1555e6ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1555e6ad",
  null
  
)

export default component.exports